<section class="testimonials-section">

  <!-- Background decorative elements -->
  <div class="bg-decoration" aria-hidden="true">
    <div class="bg-orb bg-orb--1"></div>
    <div class="bg-orb bg-orb--2"></div>
  </div>

  <div class="container">

    <!-- Header -->
    <div class="testimonials-header">
      <span class="section-label">{{'Cars_TestimonialsTitle' | translate}}</span>
      <h2 class="testimonials-title">
        {{'GB_Registration_TestimonialsSubtitle' | translate}}
      </h2>
    </div>

    <!-- Grid -->
    <div class="testimonials-grid">
      @for(t of testimonials; track t; let i = $index) {
        <div class="testimonial-card" [class.card--featured]="i === 0">

          <div class="card-inner">
            <span class="quote-mark" aria-hidden="true">&ldquo;</span>

            <p class="quote-text">{{ t.text }}</p>

            <div class="card-footer">
              <div class="avatar">
                <span>{{ t.initials }}</span>
              </div>
              <div class="author-info">
                <strong class="author-name">{{ t.title }}</strong>
                <span class="author-company">{{ t.company }}</span>
              </div>
              <div class="card-accent"></div>
            </div>
          </div>

        </div>
      }
    </div>

  </div>
</section>
